import {Directive, EventEmitter, HostListener, Output, ElementRef} from '@angular/core';

@Directive({
    selector: '[outsideClick]',
})
export class OutsideClickDirective {
    @Output()
    outsideClick: EventEmitter<MouseEvent> = new EventEmitter();

    @HostListener('document:mousedown', ['$event'])
    onClick(event: MouseEvent): void {
        if (!this.elementRef.nativeElement.contains(event.target) 
            && !((event.target as HTMLElement).id == 'connexion') 
            && !((event.target as HTMLElement).parentElement.id == 'connexion')
            && !((event.target as HTMLElement).id == 'device-login-save') 
            && !((event.target as HTMLElement).parentElement.id == 'device-login-save')
            && !((event.target as HTMLElement).id == 'device-login') 
            && !((event.target as HTMLElement).parentElement.id == 'device-login')
        ) {
            this.outsideClick.emit(event);
        }
    }

    constructor(private elementRef: ElementRef) { }
}
